import Graphic = require("esri/Graphic");
import Polyline = require("esri/geometry/Polyline");
import Polygon = require("esri/geometry/Polygon");
import CIMSymbol = require("esri/symbols/CIMSymbol");
import Font = require("esri/symbols/Font");
import SimpleFillSymbol = require("esri/symbols/SimpleFillSymbol");
import SimpleLineSymbol = require("esri/symbols/SimpleLineSymbol");
import TextSymbol = require("esri/symbols/TextSymbol");

// @ts-ignore
import * as geometryEngine from "esri/geometry/geometryEngine";

// @ts-ignore
import { createAreaMeasurementLabel } from "esri/widgets/AreaMeasurement2D/AreaMeasurement2DTool";

// @ts-ignore
import { createDistanceMeasurementLabel } from "esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DTool";

// @ts-ignore
import * as colorUtils from "esri/core/colorUtils";

export function updateAreaGraphicsPlanar(tool) {
  if (tool._vertices.length < 2) {
    tool._measurementLayer.removeAll();
    return;
  }
  const vertices = tool._vertices.map(({ coord }) => coord);

  // const areaMeasurementInfo = createAreaMeasurementInfo2D(
  //   vertices,
  //   tool.view.spatialReference,
  //   tool.geodesicDistanceThreshold
  // );
  // if (!areaMeasurementInfo) {
  //   return;
  // }
  // const { measurement, fillGeometry, outlineGeometry } = areaMeasurementInfo;
  // tool._set("measurement", measurement);

  const spatialReference = tool.view.spatialReference;
  let info;
  if (vertices.length === 2) {
    // When there are only two vertices only illustrate a leading line.
    const original = new Polyline({
      paths: vertices,
      spatialReference
    });
    let drawing: Polyline = original;
    info = {
      measurement: null,
      fillGeometry: null,
      outlineGeometry: drawing
    };
  } else {
    // Three or more vertices. Render area and perform area/perimeter computation.
    vertices.push(vertices[0]);

    const originalOutline = new Polyline({
      paths: [vertices],
      spatialReference
    });
    const originalFill = new Polygon({
      rings: [vertices],
      spatialReference
    });

    const drawOutline = originalOutline;
    const drawFill = geometryEngine.simplify(originalFill);
    if (!drawFill) {
      return null;
    }

    const planarLength = geometryEngine.planarLength(originalOutline, "meters");
    const perimeter = planarLength;
    // @ts-ignore
    const area = geometryEngine.planarArea(drawFill, "square-meters");
    info = {
      measurement: {
        geometry: drawFill,
        area,
        perimeter
      },
      fillGeometry: drawFill,
      outlineGeometry: drawOutline
    }
  }

  const { measurement, fillGeometry, outlineGeometry }  = info;
  tool._set("measurement", measurement);

  const label = measurement ? createAreaMeasurementLabel(tool.messages, measurement, tool.unit) : null;
  tool._set("measurementLabel", label);

  if (!fillGeometry && !outlineGeometry) {
    return;
  }

  let measurementFill: Graphic, measurementOutline: Graphic, measurementLabel: Graphic;

  const { graphics } = tool._measurementLayer;
  const graphicsAlreadyExist = graphics.length === 3;

  const { effectiveTheme } = tool.view; 

  if (graphicsAlreadyExist) {
    measurementFill = graphics.at(0)!;
    measurementOutline = graphics.at(1)!;
    measurementLabel = graphics.at(2)!;
  } else {
    measurementFill = new Graphic({
      symbol: new SimpleFillSymbol({
        color: colorUtils.multiplyOpacity(effectiveTheme.accentColor, 0.3),
        outline: null
      })
    });
    measurementOutline = new Graphic({
      symbol: new SimpleLineSymbol({
        color: effectiveTheme.accentColor,
        width: 2
      })
    });
    measurementLabel = new Graphic({
      symbol: new TextSymbol({
        color: effectiveTheme.textColor,
        haloColor: colorUtils.multiplyOpacity(colorUtils.getContrast(effectiveTheme.textColor), 0.5),
        font: new Font({
          size: 14,
          family: "sans-serif"
        }),
        
        haloSize: 2
      })
    });

    graphics.removeAll();
    graphics.addMany([measurementFill, measurementOutline, measurementLabel]);
  }

  measurementFill.geometry = fillGeometry;
  measurementOutline.geometry = outlineGeometry;
  // @ts-ignore
  measurementLabel.geometry = fillGeometry?.centroid;
  (<TextSymbol>measurementLabel.symbol).text = label?.area ?? "";
}

export function updatePolylinesPlanar(tool) {
  if (tool._vertices.length < 2) {
    tool._measurementLayer.removeAll();
    return;
  }
  const vertices = tool._vertices.map(({ coord }) => coord);

  // const { measurement, drawing, original } = createDistanceMeasurementInfo2D(
  //   vertices,
  //   tool.view.spatialReference,
  //   tool.geodesicDistanceThreshold
  // );
  const original = new Polyline({
    paths: [vertices],
    spatialReference: tool.view.spatialReference
  });
  const drawing = original;
  const measurement = {
    geometry: drawing,
    length: geometryEngine.planarLength(original,"meters")
  }
  tool._set("measurement", measurement);

  const label = createDistanceMeasurementLabel(tool.messages, measurement, tool.unit);
  tool._set("measurementLabel", label);

  let measurementLine, measurementLabel;

  const { graphics } = tool._measurementLayer;
  const graphicsAlreadyExist = graphics.length === 2;

  const { effectiveTheme } = tool.view;

  if (graphicsAlreadyExist) {
    measurementLine = graphics.at(0);
    measurementLabel = graphics.at(1);
  } else {
    measurementLine = new Graphic({
      symbol: new CIMSymbol({
        data: {
          type: "CIMSymbolReference",
          symbol: {
            type: "CIMLineSymbol",
            symbolLayers: [
              {
                type: "CIMSolidStroke",
                effects: [
                  {
                    type: "CIMGeometricEffectDashes",
                    dashTemplate: [14, 12],
                    lineDashEnding: "FullGap",
                    // @ts-ignore
                    controlPointEnding: "NoConstraint"
                  }
                ],
                enable: true,
                capStyle: "Butt",
                joinStyle: "Round",
                width: 3.5,
                color: colorUtils.getContrast(effectiveTheme.accentColor).toArray()
              },
              {
                type: "CIMSolidStroke",
                enable: true,
                capStyle: "Butt",
                joinStyle: "Round",
                width: 5,
                color: effectiveTheme.accentColor.toArray()
              }
            ]
          }
        }
      })
    });
    measurementLabel = new Graphic({
      symbol: new TextSymbol({
        color: effectiveTheme.textColor,
        haloColor: colorUtils.multiplyOpacity(colorUtils.getContrast(effectiveTheme.textColor), 0.5),
        haloSize: 2,
        font: new Font({
          size: 14,
          family: "sans-serif"
        })
      })
    });

    graphics.removeAll();
    graphics.addMany([measurementLine, measurementLabel]);
  }

  measurementLine.geometry = drawing;
  measurementLabel.geometry = original.extent?.center;
  measurementLabel.symbol.text = label;    
}